/*
 * Safe Play condition id
 * used to find the condition to check for the Safe Play status
 */
export const CONDITION_SAFE_PLAY_ID = '00000000-0000-0000-0000-000000000054';
